export default __webpack_public_path__ + "static/media/emoji-rocket-up.906f5eac.svg";